<template>
  <div>
    <label v-if="fieldLabel" data-test="fieldLabel">
      {{ fieldLabel }}
      &nbsp;
    </label>
    <template v-if="fieldHelpText">
      <span v-tooltip:top="fieldHelpText" class="c-black f-14" data-test="fieldHelpText">
        <i class="zmdi zmdi-help" />
      </span>
      &nbsp;
    </template>
    <slot name="content-extra-for-label" />
    <template v-if="showEditButton">
      &nbsp;
      <label class="c-indigo-500 pointer" data-test="showEditButton" @click="enterEditMode">
        {{ $t('Edit') }}
      </label>
    </template>
    <br />
    <div v-show="inDisplayMode" class="base-edit-display-content" data-test="inDisplayMode">
      <div>
        <slot name="content-for-display-mode">
          <span
            v-if="!preventEdits"
            class="label label-default bgm-yellow faded"
            @click="enterEditMode"
          >
            {{ $t('Add') }}
          </span>
          <span v-else>--</span>
        </slot>
      </div>
    </div>
    <template v-if="!preventEdits">
      <div v-show="inEditMode" data-test="inEditMode">
        <slot name="content-for-edit-mode" />
      </div>
    </template>
  </div>
</template>

<script>
export default {
  props: {
    fieldLabel: { type: String, default: '' },
    fieldHelpText: { type: String, default: '' },
    /**
     * When inEditMode we display the content-for-edit-mode right away, no need
     * to wait until the user clicks the edit button
     */
    defaultToEditMode: { type: Boolean, default: false },
    /**
     * When not inEditMode we display the content-for-display-mode, along with a button
     * allowing user to enter into the edit mode. But sometimes we just want to display
     * the content and not allow the user to click and enter edit mode
     */
    preventEdits: { type: Boolean, default: false },
  },
  data() {
    return {
      inEditMode: false,
      hasEverEnteredEditMode: false,
    }
  },
  computed: {
    showEditButton() {
      return !this.hasEverEnteredEditMode && !this.preventEdits && !this.inEditMode
    },
    inDisplayMode() {
      if (this.preventEdits) {
        return true
      }
      return !this.defaultToEditMode && !this.inEditMode
    },
  },
  watch: {
    inDisplayMode: {
      immediate: true,
      handler(newInDisplayMode) {
        if (!newInDisplayMode) {
          this.enterEditMode()
        }
      },
    },
  },
  methods: {
    enterEditMode() {
      this.inEditMode = true
      this.$emit('toggleEdit')
      this.hasEverEnteredEditMode = true
    },
  },
}
</script>

<style scoped>
.label {
  cursor: pointer;
  font-weight: 400;
}
.base-edit-display-content {
  color: #777787 !important;
  font-weight: 400;
}
</style>
